/* types.js - PropTypes for common Script-Creator-specific types. Supports use of
 * propTypes.shape() in propTypes declarations to be more specific than propTypes.object.
 */

import propTypes from 'prop-types';
import { UNIT_TYPES } from 'constants/unitTypes';

export const unitValue = propTypes.shape({
  q: propTypes.number.isRequired,
  u: propTypes.oneOf(Object.values(UNIT_TYPES))
});

export const bins = propTypes.arrayOf(propTypes.arrayOf(propTypes.number).isRequired);

export const scenario = propTypes.shape({
  product: propTypes.shape({
    brand: propTypes.string.isRequired,
    name: propTypes.string.isRequired
  }).isRequired,
  avgEstYield: unitValue.isRequired,
  avgRate: unitValue.isRequired,
  avgEstGrossRevenue: unitValue.isRequired,
  costSeedPerAcre: unitValue.isRequired,
  numSeedBags: unitValue.isRequired,
  seedChartData: propTypes.shape({
    areaValues: propTypes.arrayOf(propTypes.number).isRequired,
    seedRateBins: bins.isRequired
  }).isRequired
});

export const fertilizerProductId = propTypes.string;
export const seedProductId = propTypes.number;
export const productId = propTypes.oneOfType([fertilizerProductId, seedProductId]);
export const placement = propTypes.oneOf(['top', 'bottom', 'left', 'right']);
export const tooltipSkin = propTypes.oneOf(['light', 'dark']);
export const rgb = propTypes.shape({
  r: propTypes.number.isRequired,
  g: propTypes.number.isRequired,
  b: propTypes.number.isRequired
});

const exports = {
  bins,
  fertilizerProductId,
  placement,
  productId,
  rgb,
  scenario,
  seedProductId,
  tooltipSkin,
  unitValue
};

export default exports;
